export function getDisplayFormat(country = 'default') {
  const all = [
    {
      country: 'AD',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AE',
      multilineFormat: 'ACs',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'AF',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AG',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AI',
      multilineFormat: 'ACp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'AL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AM',
      multilineFormat: 'APCS',
      singleLineFormat:
        '{{street}}, {{postalCode}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'AO',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'AR',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AS',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'AT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AU',
      multilineFormat: 'ACsp',
      singleLineFormat:
        '{{street}}, {{city}} {{stateCode}} {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'AW',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AX',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'AZ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BA',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BB',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BD',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} - {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'BE',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BF',
      multilineFormat: 'Ac',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'BG',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BH',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'BI',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BJ',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BM',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'BN',
      multilineFormat: 'ACsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'BO',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BQ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BR',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}} - {{stateCode}}, {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'BS',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BT',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'BV',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BW',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'BY',
      multilineFormat: 'spcA',
      singleLineFormat:
        '{{stateCode}}, {{postalCode}} {{city}}, {{street}}, {{country}}',
      states: '',
    },
    {
      country: 'BZ',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CA',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'CC',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}} {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'CD',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CF',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CG',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CH',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CI',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CK',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CM',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CN',
      multilineFormat: 'AcSP',
      singleLineFormat:
        '{{street}}, {{city}}, {{state}} {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'CO',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'CR',
      multilineFormat: 'Ascp',
      singleLineFormat:
        '{{street}}, {{stateCode}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'CU',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'CV',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CW',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CX',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}} {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'CY',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'CZ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'DE',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'DJ',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'DK',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'DM',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'DO',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'DZ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'EC',
      multilineFormat: 'APC',
      singleLineFormat:
        '{{street}}, {{postalCode}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'EE',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'EG',
      multilineFormat: 'ACP',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'EH',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ER',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ES',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ET',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'FI',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'FJ',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'FK',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'FM',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'FO',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'FR',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GA',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GB',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'GD',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GE',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GF',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GG',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'GH',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GI',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GM',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GN',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'GP',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GQ',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GR',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GS',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'GT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}}-{{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GU',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'GW',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'GY',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    // Locale-specific entry - use HK instead
    // {
    //   country: 'HK_en',
    //   multilineFormat: 'Acs',
    //   singleLineFormat:
    //     '{{street}}, {{city}}, {{stateCode}}, {{country}}',
    //   states: '',
    // },
    {
      country: 'HK',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'HN',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'HR',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'HT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'HU',
      multilineFormat: 'CAP',
      singleLineFormat:
        '{{city}}, {{street}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'ID',
      multilineFormat: 'Acps',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'IE',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'IL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'IM',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'IN',
      multilineFormat: 'Acps',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{stateCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'IO',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'IQ',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'IR',
      multilineFormat: 'CASP',
      singleLineFormat:
        '{{city}}, {{street}}, {{stateCode}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'IS',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'IT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'JE',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'JM',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'JO',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'JP',
      multilineFormat: 'PSCA',
      singleLineFormat:
        '{{postalCode}}, {{stateCode}}, {{city}}, {{street}}, {{country}}',
      states: 'YES',
    },
    // Locale-specific entries - use JP instead
    // {
    //   country: 'JP_en',
    //   multilineFormat: 'Acsp',
    //   singleLineFormat:
    //     '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
    //   states: '',
    // },
    // {
    //   country: 'JP_ja',
    //   multilineFormat: 'PSCA',
    //   singleLineFormat:
    //     ', {{postalCode}}, {{stateCode}}, {{city}}, {{street}}, {{country}}',
    //   states: '',
    // },
    {
      country: 'KE',
      multilineFormat: 'ACP',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'KG',
      multilineFormat: 'SpcA',
      singleLineFormat:
        '{{stateCode}}, {{postalCode}} {{city}}, {{street}}, {{country}}',
      states: '',
    },
    {
      country: 'KH',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'KI',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'KM',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'KN',
      multilineFormat: 'Acs',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'KP',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'KR',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    // Locale-specific entries - use KR instead
    // {
    //   country: 'KR_en',
    //   multilineFormat: 'Acp',
    //   singleLineFormat:
    //     '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
    //   states: '',
    // },
    // {
    //   country: 'KR_ko',
    //   multilineFormat: 'CAP',
    //   singleLineFormat:
    //     '{{stateCode}}, {{city}}, {{street}}, {{postalCode}}, {{country}}',
    //   states: '',
    // },
    {
      country: 'KW',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}} {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'KY',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'KZ',
      multilineFormat: 'SpcA',
      singleLineFormat:
        '{{stateCode}}, {{postalCode}} {{city}}, {{street}}, {{country}}',
      states: '',
    },
    {
      country: 'LA',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'LB',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'LC',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'LI',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'LK',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'LR',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'LS',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'LT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'LU',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'LV',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'LY',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MA',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MC',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MD',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ME',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MF',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MG',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MH',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'MK',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ML',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MM',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'MN',
      multilineFormat: 'APC',
      singleLineFormat:
        '{{street}}, {{postalCode}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MO',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    // Locale-specific entry - use MO instead
    // {
    //   country: 'MO_zh',
    //   multilineFormat: 'CA',
    //   singleLineFormat: ', {{city}}, {{street}}, {{country}}',
    //   states: '',
    // },
    {
      country: 'MP',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'MQ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MR',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MS',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MT',
      multilineFormat: 'ACP',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'MU',
      multilineFormat: 'AC',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MV',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'MW',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'MX',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{stateCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'MY',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{stateCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'MZ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NA',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'NC',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NE',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NF',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}} {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'NG',
      multilineFormat: 'Acps',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'NI',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NO',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NP',
      multilineFormat: 'ACsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'NR',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NU',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'NZ',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'OM',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'PA',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'PE',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'PF',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PG',
      multilineFormat: 'Acps',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}} {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'PH',
      multilineFormat: 'Acps',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}} {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'PK',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'PL',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PM',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PN',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PR',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'PS',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PW',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'PY',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'QA',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'RE',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'RO',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'RS',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'RU',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'RW',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SA',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'SB',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SC',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SD',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SE',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SG',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'SH',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'SI',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SJ',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SK',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'SL',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SM',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SN',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SO',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SR',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SS',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ST',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SV',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}} - {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'SX',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SY',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'SZ',
      multilineFormat: 'ACp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'TC',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'TD',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TF',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TG',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TH',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'TJ',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TK',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'TL',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TM',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TN',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TO',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TR',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'TT',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'TV',
      multilineFormat: 'ACs',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'TW',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{country}}',
      states: '',
    },
    // Locale-specific entries - use TW instead
    // {
    //   country: 'TW_en',
    //   multilineFormat: 'Acp',
    //   singleLineFormat:
    //     '{{street}}, {{city}} {{postalCode}}, {{country}}',
    //   states: '',
    // },
    // {
    //   country: 'TW_zh',
    //   multilineFormat: 'PCA',
    //   singleLineFormat:
    //     '{{postalCode}}, {{city}}, {{street}}, {{country}}',
    //   states: '',
    // },
    {
      country: 'TZ',
      multilineFormat: 'Apcs',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'UA',
      multilineFormat: 'ACP',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'UG',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'UM',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'US',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'UY',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'UZ',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'VA',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'VC',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'VE',
      multilineFormat: 'Acps',
      singleLineFormat:
        '{{street}}, {{city}} {{postalCode}}, {{stateCode}}, {{country}}',
      states: '',
    },
    {
      country: 'VG',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, [island], {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'VI',
      multilineFormat: 'Acsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'VN',
      multilineFormat: 'ACsp',
      singleLineFormat:
        '{{street}}, {{city}}, {{stateCode}} {{postalCode}}, {{country}}',
      states: 'YES',
    },
    {
      country: 'VU',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'WF',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'WS',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'YE',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'YT',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ZA',
      multilineFormat: 'ACp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
      states: '',
    },
    {
      country: 'ZM',
      multilineFormat: 'Apc',
      singleLineFormat:
        '{{street}}, {{postalCode}} {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'ZW',
      multilineFormat: 'Ac',
      singleLineFormat: '{{street}}, {{city}}, {{country}}',
      states: '',
    },
    {
      country: 'DEFAULT',
      multilineFormat: 'Acp',
      singleLineFormat:
        '{{street}}, {{city}}, {{postalCode}}, {{country}}',
    },
  ];

  if (all.filter((x) => x.country === country).length > 0) {
    return all.filter((x) => x.country === country)[0];
  }
  return all.filter((x) => x.country === 'DEFAULT')[0];
}
